import * as React from "react";
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DateTimeInput,
  ImageField,
  SelectColumnsButton,
  FilterButton,
  CreateButton,
  ExportButton,
  TopToolbar,
} from "react-admin";
import { ImportButton } from "react-admin-import-csv";
import { CustomDeleteButton } from './CustomDeleteButtons';

const NewsFeedFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="title" alwaysOn />
    <TextInput label="Category" source="category" />
  </Filter>
);

const ListActions = (props) => (
  <TopToolbar>
    <CreateButton {...props} />
    <ExportButton {...props} />
    <ImportButton {...props} />
  </TopToolbar>
);

export const NewsFeedList = (props) => (
  <List {...props} filters={<NewsFeedFilter />} actions={<ListActions />}>
    <Datagrid>
      <TextField source="title" label="Title" />
      <TextField source="category" label="Category" />
      <ImageField source="image_url" label="Image" />
      <TextField source="date" label="Publication Date" />
      <ShowButton label="" />
      <EditButton label="" />
      <CustomDeleteButton label="" redirect={false} />
    </Datagrid>
  </List >
);

export const NewsFeedShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="title" label="Title" />
      <TextField source="category" label="Category" />
      <ImageField source="image_url" label="Image" />
      <TextField source="content" label="Content" />
      <TextField source="date" label="Publication Date" />
    </SimpleShowLayout>
  </Show>
);

export const NewsFeedCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="title" label="Title" />
      <TextInput source="category" label="Category" />
      <TextInput source="image_url" label="Image URL" />
      <TextInput source="content" label="Content" multiline />
      <DateTimeInput source="date" label="Publication Date" />
    </SimpleForm>
  </Create>
);

export const NewsFeedEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="title" label="Title" />
      <TextInput source="category" label="Category" />
      <TextInput source="image_url" label="Image URL" />
      <TextInput source="content" label="Content" multiline />
      <DateTimeInput source="date" label="Publication Date" />
    </SimpleForm>
  </Edit>
); 